/* eslint no-inline-comments: 0 */

// Professional Services, under the admin's Orders menu (Matt, 2026-10-25):
// the fix catalog (#3144) and remediation purchases (#3146) are sold work,
// not a plan, so they moved here from Organizations. Only the pages moved;
// their admin API keeps its paths (/admin/fix-catalog,
// /admin/fix-catalog/distribution, /admin/remediation/...), which the
// fix-catalog-distribution CLI reads. The old /organizations/fix-catalog and
// /organizations/remediation URLs redirect here, see organizations/_routes.js.

const Overview = () => import( /* webpackChunkName: "group-professional-services" */ `./services-overview.vue` );
const FixCatalog = () => import( /* webpackChunkName: "group-professional-services" */ `./fix-catalog.vue` );
const Remediation = () => import( /* webpackChunkName: "group-professional-services" */ `./remediation-settings.vue` );
const RemediationProject = () => import( /* webpackChunkName: "group-professional-services" */ `./remediation-project.vue` );

export default {
	path: `orders/professional-services`,
	children: [
		{
			path: ``,
			name: `professional-services`,
			component: Overview,
			meta: {
				title: `Professional Services`
			}
		},
		{
			path: `fix-catalog`,
			name: `professional-services-fix-catalog`,
			component: FixCatalog,
			meta: {
				title: `Fix Catalog`
			}
		},
		{
			path: `remediation`,
			name: `professional-services-remediation`,
			component: Remediation,
			meta: {
				title: `Remediation`
			}
		},
		{
			// remediation.AdminProjectURL links here from the services team's
			// Slack notice.
			path: `remediation/:uuid`,
			name: `professional-services-remediation-project`,
			component: RemediationProject,
			meta: {
				title: `Remediation Project`
			}
		}
	]
};
